export class SelfAssessmentJudgement {
  id: number;
  summaryDetailsId: number;
  referenceNumber: string;
  title: string;
  topic: string;
  implementationDate: Date;
  implementationStatus: string;
  lbgMateriality: string;
  rfbMateriality: string;
  lbcmMateriality: string;
  submitterName: string;
  estimatedImpactLBG: string;
  estimatedImpactRFB: string;
  estimatedImpactLBCM: string;
  judgementDetails: string;
  judgementImplementationComments: string;
  reviewDate: Date;
  reviewerName: string;
  natureOfReview: string;
  reviewStatus: string;
  reviewOutcome: string;
  reviewerComments: string;
  approvers: string;
  approverDate: Date;
  conditionalApproval: boolean;
  nextApprovalDue: Date;
  confirmApproval: string;
  approvalStatus: string;
  readyForApproval: boolean;
  approverComments: string;
  actionType: string;
  actionOwner: string;
  actionDueDate: Date;
  actionClosed: Date;
  actionDetails: string;
  actionClosure: string;
  muteJudgementDetailsUsers: string;
  muteJudgementImplementationCommentsUsers: string;
  muteReviewerCommentsUsers: string;
  muteApproverCommentsUsers: string;
  readyForReview: boolean;
  muteActionDetailsUsers: string;
  muteActionClosureUsers: string;
  constructor() {
    this.id = 0;
    this.summaryDetailsId = 0;
    this.referenceNumber = '';
    this.title = '';
    this.topic = '';
    this.implementationDate = new Date();
    this.implementationStatus = '';
    this.lbgMateriality = '';
    this.rfbMateriality = '';
    this.lbcmMateriality = '';
    this.submitterName = '';
    this.estimatedImpactLBG = '';
    this.estimatedImpactRFB = '';
    this.estimatedImpactLBCM = '';
    this.judgementDetails = '';
    this.judgementImplementationComments = '';
    this.reviewDate = new Date();
    this.reviewerName = '';
    this.natureOfReview = '';
    this.reviewStatus = '';
    this.reviewOutcome = '';
    this.reviewerComments = '';
    this.approvers = '';
    this.approverDate = new Date();
    this.nextApprovalDue = new Date();
    this.confirmApproval = '';
    this.approvalStatus = '';
    this.approverComments = '';
    this.actionType = '';
    this.actionOwner = '';
    this.actionDueDate = new Date();
    this.actionClosed = new Date();
    this.actionDetails = '';
    this.actionClosure = '';
    this.muteJudgementDetailsUsers = '';
    this.muteJudgementImplementationCommentsUsers = '';
    this.muteReviewerCommentsUsers = '';
    this.muteApproverCommentsUsers = '';
    this.readyForReview = false;
    this.muteActionDetailsUsers = '';
    this.readyForApproval = false;
    this.conditionalApproval = false;
    this.muteActionClosureUsers = '';
  }
}
